import React from 'react';
import LoadingIssueRankings from '../../../components/generic-dashboards/loading/LoadingIssueRankings';
import { MissingData } from '../../../components/misc/MissingData';
import { issueInfo } from '../interface/issue-entity.interface';
import LiqExhibitTitleContainer from '../../shared/UI/layout/LiqExhibitTitleContainer';
import { Button, ButtonGroup } from '@mui/material';

// Title and subtitle are optional components with defaults specified in function signature below.
interface keywordCompositionProps {
    displayLobbyingData: boolean;
    setDisplayLobbyingData: (x: boolean) => void;
    title?: string;
    subtitle?: string;
    keywordData: issueInfo | null;
    loading: boolean;
}

const KeywordComposition = ({
    displayLobbyingData,
    setDisplayLobbyingData,
    title = '',
    subtitle = '',
    keywordData,
    loading,
}: keywordCompositionProps) => {
    return (
        <div>
            <div className="flex md:flex-row flex-col justify-between md:items-center gap-2 mb-2">
                <b>
                    <LiqExhibitTitleContainer
                        title={`Issue Dashboard: ${title}`}
                        subtitle={subtitle}
                    />
                </b>
                <ButtonGroup disableElevation>
                    <Button
                        onClick={() => setDisplayLobbyingData(true)}
                        variant={displayLobbyingData ? 'contained' : 'outlined'}
                    >
                        Lobbying Info
                    </Button>
                    <Button
                        onClick={() => setDisplayLobbyingData(false)}
                        variant={!displayLobbyingData ? 'contained' : 'outlined'}
                    >
                        Parliamentary Info
                    </Button>
                </ButtonGroup>
            </div>
            <hr className="h-0.5 my-3 bg-slate-100 rounded" />
            {loading ? (
                <LoadingIssueRankings />
            ) : !loading && !keywordData ? (
                <MissingData />
            ) : keywordData ? (
                <span>Issue keywords: {keywordData.keywords.join(', ')}</span>
            ) : (
                <></>
            )}
        </div>
    );
};

export default KeywordComposition;
